import {
  Box,
  Container,
  Flex,
  Image,
  Link,
  Spacer,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { FC } from 'react';
import { useWindowSize } from 'react-use';

import appLogo from 'assets/img/logos/sharespro-logo.svg';
import styles from './styles.module.scss';
import classNames from 'classnames';
import useSiteNavItems, {
  getWebSiteUrl,
} from 'hooks/shared/layout/useSiteNavItems';
import { Breakpoint } from 'presentation/theme/breakpoints';
import LangSwitcher from 'presentation/layout/shared/LangSwitcher';

export const headerHeight = 64;

interface Props {
  showDivider?: boolean;
}

/// Header has custom drawer logic because it must be same as the header in
/// Sharespro Site project (https://gitlab.com/gitsharespro/sharespro-site)
const Header: FC<Props> = ({ showDivider = false }) => {
  const { width } = useWindowSize();

  const { isOpen, onClose, onToggle } = useDisclosure();

  const navItems = useSiteNavItems();

  const itemNodes = navItems.map((nav, index) => {
    return (
      <Link
        className={classNames(styles.navItem, {
          [styles.navItemActive]: nav.isActive,
        })}
        key={index}
        href={nav.href}
      >
        <Text
          maxW="230px"
          overflow="hidden"
          textOverflow="ellipsis"
          whiteSpace="nowrap"
        >
          {nav.title}
        </Text>
        {nav.extra}
      </Link>
    );
  });

  return (
    <>
      <Box
        className={classNames(styles.header, {
          [styles.header__withDivider]: showDivider,
        })}
      >
        <Container>
          <Flex
            height="62px"
            alignItems="center"
            className={classNames({
              [styles.headerContainer_withDivider]: !showDivider,
            })}
          >
            <Link href={getWebSiteUrl('/')}>
              <Image h="32px" maxW="160px" src={appLogo} />
            </Link>
            <Spacer />
            {width >= Breakpoint.xl ? (
              <Flex alignItems="center">
                <Box mr="30px">
                  <LangSwitcher />
                </Box>
                {itemNodes}
              </Flex>
            ) : (
              <button
                className={classNames(styles.hamburger, {
                  [styles.hamburgerOpened]: isOpen,
                })}
                onClick={onToggle}
              >
                <Box className={styles.hamburgerBarItem1} />
                <Box className={styles.hamburgerBarItem2} />
                <Box className={styles.hamburgerBarItem3} />
              </button>
            )}
          </Flex>
        </Container>
      </Box>
      <Box
        className={classNames(styles.navMobile, {
          [styles.navOpened]: isOpen,
        })}
      >
        <Container>
          <Box className={styles.navItem}>
            <LangSwitcher />
          </Box>
          {itemNodes}
        </Container>
      </Box>
      {isOpen && (
        <Box onClick={onClose} className={classNames(styles.overlay)} />
      )}
    </>
  );
};

export default Header;
